import type { AgentCapability as AgentCapabilityModel } from '@/adapters/catalogv1.g';

export function extractAgentCapability(model: AgentCapabilityModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    agentRef: model.agent_ref ?? '',
    capabilityRef: model.capability_ref ?? '',
    capabilityType: model.capability_type,
    name: model.name,
    description: model.description,
    targetResourceRef: model.target_resource_ref,
    implementationRef: model.implementation_ref,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentCapability = ReturnType<typeof extractAgentCapability>;
